import React from "react"
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons"

import CardItem from "../components/CardItem"


const FaqItem = (props) => 
    <CardItem icon={faQuestionCircle} {...props} />

export default FaqItem